import React from "react";
import "./FormInputs.css";

interface Props {
  maxLength?: number;
  type: string;
  register: any;
  placeholder?: string;
  name: string;
  required?: boolean | string;
  pattern?: RegExp;
  message?: string;
  errors: any;
  prevent: any;
  disabled: any
}

const FormInputs: React.FC<Props> = ({
  maxLength,
  type,
  register,
  placeholder,
  name,
  required,
  pattern,
  message,
  errors,
  prevent,
  disabled
}) => {

  return (
    <div className="common-outer">
      <div className="common-email-form">
        <input
          style={name === 'password' ? {paddingRight: 45} : {}}
          maxLength={maxLength}
          type={type}
          placeholder={placeholder}
          {...register(name, {
            required: required ? message : false,
            pattern: pattern ? { value: pattern, message } : undefined,
          })}
          onCopy={prevent}
          onCut={prevent}
          onPaste={prevent}
          disabled={disabled}
        />
      </div>
      {errors?.[name] && (
        <p className="common-error">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default FormInputs;
